var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationCircleDynamicFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21875 7.99855C1.21875 4.27143 4.24018 1.25 7.9673 1.25C11.6944 1.25 14.7158 4.27143 14.7158 7.99855C14.7158 11.7257 11.6944 14.7471 7.9673 14.7471C4.24018 14.7471 1.21875 11.7257 1.21875 7.99855ZM7.96741 4.5C7.55319 4.5 7.21741 4.83579 7.21741 5.25V5.255C7.21741 5.66921 7.55319 6.005 7.96741 6.005H7.97241C8.38662 6.005 8.72241 5.66921 8.72241 5.255V5.25C8.72241 4.83579 8.38662 4.5 7.97241 4.5H7.96741ZM6.79671 7.83395C6.91448 8.06948 7.13945 8.21596 7.38291 8.24384L7.00352 9.76139C6.74453 10.7973 7.81994 11.66 8.77504 11.1825L8.77507 11.1824L8.80272 11.1686C9.1732 10.9834 9.32335 10.5329 9.1381 10.1624C9.02033 9.92686 8.79536 9.78038 8.55191 9.75251L8.93129 8.23496C9.19028 7.199 8.11488 6.33634 7.15977 6.81389L7.15977 6.81389L7.13212 6.82772C6.76163 7.01296 6.61147 7.46347 6.79671 7.83395Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleDynamicFill);
export default __webpack_public_path__ + "static/media/information-circle-dynamic-fill.676334c52a8d910a311ac38f5661bcc1.svg";
export { ForwardRef as ReactComponent };